/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExcludedPosition } from './ExcludedPosition';
import {
    ExcludedPositionFromJSON,
    ExcludedPositionFromJSONTyped,
    ExcludedPositionToJSON,
} from './ExcludedPosition';
import type { InferredPosition } from './InferredPosition';
import {
    InferredPositionFromJSON,
    InferredPositionFromJSONTyped,
    InferredPositionToJSON,
} from './InferredPosition';

/**
 * 
 * @export
 * @interface PortfolioInferredPositions
 */
export interface PortfolioInferredPositions {
    /**
     * 
     * @type {string}
     * @memberof PortfolioInferredPositions
     */
    portfolioGuid: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioInferredPositions
     */
    cash?: number;
    /**
     * 
     * @type {Array<InferredPosition>}
     * @memberof PortfolioInferredPositions
     */
    positions: Array<InferredPosition>;
    /**
     * 
     * @type {Array<ExcludedPosition>}
     * @memberof PortfolioInferredPositions
     */
    excludedPositions: Array<ExcludedPosition>;
}

/**
 * Check if a given object implements the PortfolioInferredPositions interface.
 */
export function instanceOfPortfolioInferredPositions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "portfolioGuid" in value;
    isInstance = isInstance && "positions" in value;
    isInstance = isInstance && "excludedPositions" in value;

    return isInstance;
}

export function PortfolioInferredPositionsFromJSON(json: any): PortfolioInferredPositions {
    return PortfolioInferredPositionsFromJSONTyped(json, false);
}

export function PortfolioInferredPositionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioInferredPositions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioGuid': json['portfolio_guid'],
        'cash': !exists(json, 'cash') ? undefined : json['cash'],
        'positions': ((json['positions'] as Array<any>).map(InferredPositionFromJSON)),
        'excludedPositions': ((json['excluded_positions'] as Array<any>).map(ExcludedPositionFromJSON)),
    };
}

export function PortfolioInferredPositionsToJSON(value?: PortfolioInferredPositions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolio_guid': value.portfolioGuid,
        'cash': value.cash,
        'positions': ((value.positions as Array<any>).map(InferredPositionToJSON)),
        'excluded_positions': ((value.excludedPositions as Array<any>).map(ExcludedPositionToJSON)),
    };
}

